import { Alert } from 'foundations-components/transitional/components/Alert';
import { useIsUngated, useSampleContactContext } from 'crm-events-data';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/transitional/components/View';
import { gate } from 'hub-http/gates';
import { jsx as _jsx } from "react/jsx-runtime";
const SampleEventsDeprecationBanner = () => {
  const isSampleContact = useSampleContactContext();
  const isUngated = useIsUngated();
  const isUngatedForSampleEventsDeprecation = isUngated('SampleEngagements') || isUngated(gate('hs-crm-events-backend:sample-engagements'));
  if (!isSampleContact || isUngatedForSampleEventsDeprecation) {
    return null;
  }
  return /*#__PURE__*/_jsx(View, {
    paddingInline: "400",
    as: "div",
    children: /*#__PURE__*/_jsx(Alert, {
      type: "warning",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "timeline.sampleEventsDeprecationBanner.deprecationTitle"
      })
    })
  });
};
export default SampleEventsDeprecationBanner;